import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Nombrar la herida",
    opening: localizedGenderNode(
      [
      "Hoy dejo de difuminarlo. Algo en mí fue herido — y estoy dispuesto/a a reconocerlo."
    ],
      [
      "Hoy dejo de difuminarlo. Algo en mí fue herido — y estoy dispuesto/a a reconocerlo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración lenta.",
      "Me digo en silencio: “Si duele, hay una razón.”"
    ],
      [
      "Pauso conmigo.",
      "Una respiración lenta.",
      "Me digo en silencio: “Si duele, hay una razón.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué ocurrió exactamente que hizo que mi confianza se quebrara?",
      "¿Cuál es la primera emoción que surge cuando lo recuerdo?",
      "¿Qué es lo más difícil de admitir que fue herido en mí?"
    ],
      [
      "¿Qué ocurrió exactamente que hizo que mi confianza se quebrara?",
      "¿Cuál es la primera emoción que surge cuando lo recuerdo?",
      "¿Qué es lo más difícil de admitir que fue herido en mí?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Hoy no exagero ni minimizo. Reconozco la herida."
    ],
      [
      "Cierre",
      "Hoy no exagero ni minimizo. Reconozco la herida."
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy — mano en el pecho + respiración + la frase: “Tengo derecho a sentir.”",
      "Una vez hoy — mano en el pecho + respiración + la frase: “Tengo derecho a sentir.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Impacto y confusión",
    opening: localizedGenderNode(
      [
      "Hoy permito la confusión sin exigirme claridad."
    ],
      [
      "Hoy permito la confusión sin exigirme claridad."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración. “La confusión es una respuesta a la herida.”"
    ],
      [
      "Pauso conmigo.",
      "Una respiración. “La confusión es una respuesta a la herida.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué cambió en mí después de descubrir la verdad?",
      "¿Qué pensamientos se repiten una y otra vez?",
      "¿Dónde siento la inestabilidad en el cuerpo?"
    ],
      [
      "¿Qué cambió en mí después de descubrir la verdad?",
      "¿Qué pensamientos se repiten una y otra vez?",
      "¿Dónde siento la inestabilidad en el cuerpo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La confusión no significa debilidad. Significa que algo se movió."
    ],
      [
      "Cierre",
      "La confusión no significa debilidad. Significa que algo se movió."
    ]
    ),
    action: localizedGenderNode(
      "10 minutos sin pantallas — solo estar.",
      "10 minutos sin pantallas — solo estar."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "La grieta en la confianza",
    opening: localizedGenderNode(
      [
      "Hoy observo la confianza rota sin culparme."
    ],
      [
      "Hoy observo la confianza rota sin culparme."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿En qué confiaba — y qué se rompió?",
      "¿Qué me sucede cuando ya no estoy seguro/a?",
      "¿Qué parte de mí intenta protegerse ahora?"
    ],
      [
      "¿En qué confiaba — y qué se rompió?",
      "¿Qué me sucede cuando ya no estoy seguro/a?",
      "¿Qué parte de mí intenta protegerse ahora?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La confianza es un cimiento. Cuando se agrieta, el cuerpo reacciona."
    ],
      [
      "Cierre",
      "La confianza es un cimiento. Cuando se agrieta, el cuerpo reacciona."
    ]
    ),
    action: localizedGenderNode(
      "Escribir una palabra que describa la grieta — y cerrar el cuaderno.",
      "Escribir una palabra que describa la grieta — y cerrar el cuaderno."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Preguntas sin respuesta",
    opening: localizedGenderNode(
      [
      "Hoy me encuentro con la necesidad de saber sin hundirme."
    ],
      [
      "Hoy me encuentro con la necesidad de saber sin hundirme."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración. “No toda pregunta necesita respuesta hoy.”"
    ],
      [
      "Pauso conmigo.",
      "Una respiración. “No toda pregunta necesita respuesta hoy.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué pregunta me persigue más?",
      "¿Qué espero que ocurra si lo sé todo?",
      "¿Cómo se siente mi cuerpo cuando busco respuestas?"
    ],
      [
      "¿Qué pregunta me persigue más?",
      "¿Qué espero que ocurra si lo sé todo?",
      "¿Cómo se siente mi cuerpo cuando busco respuestas?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "A veces el silencio importa más que toda la verdad."
    ],
      [
      "Cierre",
      "A veces el silencio importa más que toda la verdad."
    ]
    ),
    action: localizedGenderNode(
      "Pausa de 30 segundos antes de revisar o investigar.",
      "Pausa de 30 segundos antes de revisar o investigar."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "La ira",
    opening: localizedGenderNode(
      [
      "Hoy le doy espacio a la ira sin destruirme."
    ],
      [
      "Hoy le doy espacio a la ira sin destruirme."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración. “Tengo derecho a sentir ira.”"
    ],
      [
      "Pauso conmigo.",
      "Una respiración. “Tengo derecho a sentir ira.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿De qué se trata realmente mi ira?",
      "¿Qué límite intenta restaurar?",
      "¿Cómo puedo liberar la ira sin dañarme?"
    ],
      [
      "¿De qué se trata realmente mi ira?",
      "¿Qué límite intenta restaurar?",
      "¿Cómo puedo liberar la ira sin dañarme?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La ira es energía — no un veredicto."
    ],
      [
      "Cierre",
      "La ira es energía — no un veredicto."
    ]
    ),
    action: localizedGenderNode(
      "10 minutos de movimiento (caminar / estirarse).",
      "10 minutos de movimiento (caminar / estirarse)."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Vergüenza y comparación",
    opening: localizedGenderNode(
      [
      "Hoy separo la herida de mi valor personal."
    ],
      [
      "Hoy separo la herida de mi valor personal."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué frase de vergüenza aparece en mí?",
      "¿Con quién me comparo?",
      "¿Qué verdad suave existe sobre mí incluso ahora?"
    ],
      [
      "¿Qué frase de vergüenza aparece en mí?",
      "¿Con quién me comparo?",
      "¿Qué verdad suave existe sobre mí incluso ahora?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Ser herido/a no define quién soy."
    ],
      [
      "Cierre",
      "Ser herido/a no define quién soy."
    ]
    ),
    action: localizedGenderNode(
      "Escribir una cualidad en mí que no desapareció.",
      "Escribir una cualidad en mí que no desapareció."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "El cuerpo recuerda",
    opening: localizedGenderNode(
      [
      "Mi cuerpo cuenta una historia — y escucho."
    ],
      [
      "Mi cuerpo cuenta una historia — y escucho."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración lenta."
    ],
      [
      "Pauso conmigo.",
      "Una respiración lenta."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cómo reacciona mi cuerpo cuando estoy cerca de mi pareja?",
      "¿Cómo reacciona cuando estoy a solas?",
      "¿Cuál es la diferencia?"
    ],
      [
      "¿Cómo reacciona mi cuerpo cuando estoy cerca de mi pareja?",
      "¿Cómo reacciona cuando estoy a solas?",
      "¿Cuál es la diferencia?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El cuerpo es una señal, no un enemigo."
    ],
      [
      "Cierre",
      "El cuerpo es una señal, no un enemigo."
    ]
    ),
    action: localizedGenderNode(
      "Mano en el cuerpo + respiración cuando aparece un disparador.",
      "Mano en el cuerpo + respiración cuando aparece un disparador."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Miedo a que vuelva a ocurrir",
    opening: localizedGenderNode(
      [
      "Hoy reconozco el miedo sin dejar que mande."
    ],
      [
      "Hoy reconozco el miedo sin dejar que mande."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué es lo que más temo que vuelva a suceder?",
      "¿Qué hago para prevenir el dolor?",
      "¿Eso realmente me protege?"
    ],
      [
      "¿Qué es lo que más temo que vuelva a suceder?",
      "¿Qué hago para prevenir el dolor?",
      "¿Eso realmente me protege?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El miedo intenta cuidar — a veces a un alto costo."
    ],
      [
      "Cierre",
      "El miedo intenta cuidar — a veces a un alto costo."
    ]
    ),
    action: localizedGenderNode(
      "Escribir un miedo y ponerle punto final.",
      "Escribir un miedo y ponerle punto final."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Límites",
    opening: localizedGenderNode(
      [
      "Hoy reviso qué necesito para sentirme seguro/a."
    ],
      [
      "Hoy reviso qué necesito para sentirme seguro/a."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué límite me falta ahora?",
      "¿Qué me asusta de ponerlo?",
      "¿Cómo se ve un límite sin amenaza?"
    ],
      [
      "¿Qué límite me falta ahora?",
      "¿Qué me asusta de ponerlo?",
      "¿Cómo se ve un límite sin amenaza?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Un límite protege el corazón."
    ],
      [
      "Cierre",
      "Un límite protege el corazón."
    ]
    ),
    action: localizedGenderNode(
      "Formular un límite interno.",
      "Formular un límite interno."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "¿Se puede reconstruir la confianza?",
    opening: localizedGenderNode(
      [
      "Hoy no decido — solo exploro la posibilidad."
    ],
      [
      "Hoy no decido — solo exploro la posibilidad."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué necesitaría ver para que la confianza regrese?",
      "¿Qué ya ocurrió que me inquieta?",
      "¿Qué dice mi cuerpo sobre esta posibilidad?"
    ],
      [
      "¿Qué necesitaría ver para que la confianza regrese?",
      "¿Qué ya ocurrió que me inquieta?",
      "¿Qué dice mi cuerpo sobre esta posibilidad?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Posibilidad no es compromiso."
    ],
      [
      "Cierre",
      "Posibilidad no es compromiso."
    ]
    ),
    action: localizedGenderNode(
      "Hoy no tomar decisiones.",
      "Hoy no tomar decisiones."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Mi responsabilidad",
    opening: localizedGenderNode(
      [
      "Hoy examino mi parte sin culparme."
    ],
      [
      "Hoy examino mi parte sin culparme."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué es realmente mi responsabilidad?",
      "¿Qué no lo es?",
      "¿Cómo se ve la responsabilidad sin castigo?"
    ],
      [
      "¿Qué es realmente mi responsabilidad?",
      "¿Qué no lo es?",
      "¿Cómo se ve la responsabilidad sin castigo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La responsabilidad no requiere dolor."
    ],
      [
      "Cierre",
      "La responsabilidad no requiere dolor."
    ]
    ),
    action: localizedGenderNode(
      "Una frase de responsabilidad suave hacia mí.",
      "Una frase de responsabilidad suave hacia mí."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Quién soy ahora",
    opening: localizedGenderNode(
      [
      "Hoy me encuentro conmigo después de la herida."
    ],
      [
      "Hoy me encuentro conmigo después de la herida."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué cambió en mí?",
      "¿Qué se fortaleció a pesar de todo?",
      "¿Qué necesito más ahora?"
    ],
      [
      "¿Qué cambió en mí?",
      "¿Qué se fortaleció a pesar de todo?",
      "¿Qué necesito más ahora?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Sigo aquí."
    ],
      [
      "Cierre",
      "Sigo aquí."
    ]
    ),
    action: localizedGenderNode(
      "Una acción que me recuerde quién soy.",
      "Una acción que me recuerde quién soy."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Mirar hacia adelante",
    opening: localizedGenderNode(
      [
      "Hoy miro al futuro con suavidad."
    ],
      [
      "Hoy miro al futuro con suavidad."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué tipo de relación quiero en el futuro?",
      "¿Qué valor no volveré a abandonar?",
      "¿Cuál es un pequeño paso en esa dirección?"
    ],
      [
      "¿Qué tipo de relación quiero en el futuro?",
      "¿Qué valor no volveré a abandonar?",
      "¿Cuál es un pequeño paso en esa dirección?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El futuro se construye con pasos silenciosos."
    ],
      [
      "Cierre",
      "El futuro se construye con pasos silenciosos."
    ]
    ),
    action: localizedGenderNode(
      "Escribir un valor y conservarlo.",
      "Escribir un valor y conservarlo."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Cierre suave",
    opening: localizedGenderNode(
      [
      "Hoy no borro lo ocurrido — elijo cómo seguir."
    ],
      [
      "Hoy no borro lo ocurrido — elijo cómo seguir."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración profunda."
    ],
      [
      "Pauso conmigo.",
      "Una respiración profunda."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué suelto para proteger mi corazón?",
      "¿Qué me llevo de este camino?",
      "Frase de regreso para días difíciles:"
    ],
      [
      "¿Qué suelto para proteger mi corazón?",
      "¿Qué me llevo de este camino?",
      "Frase de regreso para días difíciles:"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre final del recorrido",
      "Mi confianza fue herida — pero yo no desaparecí.",
      "Estoy aprendiendo a escucharme,",
      "y a elegir una relación que no me obligue a encoger el corazón.",
      "Y eso es fortaleza."
    ],
      [
      "Cierre final del recorrido",
      "Mi confianza fue herida — pero yo no desaparecí.",
      "Estoy aprendiendo a escucharme,",
      "y a elegir una relación que no me obligue a encoger el corazón.",
      "Y eso es fortaleza."
    ]
    ),
    action: localizedGenderNode(
      "Una acción que simbolice lealtad hacia mí.",
      "Una acción que simbolice lealtad hacia mí."
    ),
  },
].map(buildNormalizedDay);

export const lackOfTrustInRelationshipBlueprintEs = buildNormalizedPilotBlueprint({
  id: "lack_of_trust_in_relationship_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "lack_of_trust_in_relationship",
  category: "general",
  journeyName: {
    he: "חוסר אמון בזוגיות (בגידה, שקרים, סודות)",
    en: "Lack of Trust in a Relationship (Betrayal, Lies, Secrets)",
    es: "Falta de confianza en la relación (engaño, mentiras, secretos)",
  },
  days,
});

export default lackOfTrustInRelationshipBlueprintEs;
